const datetime = (date) => {
  if (typeof date === 'string') {
    const d = new Date(date)
    return `${d.toLocaleString()}`
  }
  return date
}

const date = (date) => {
  if (typeof date === 'string') {
    return new Date(date).toLocaleDateString()
  } else if (date instanceof Date) {
    return date.toLocaleDateString()
  }
  return date
}

const scoreboardDate = (date) => {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }
  options.timeZone = 'UTC'
  options.timeZoneName = 'short'
  return date.toLocaleString('en-US', options)
}

const time = (date) => {
  if (typeof date === 'string') {
    return new Date(date).toLocaleTimeString()
  } else if (date instanceof Date) {
    return date.toLocaleTimeString()
  }
  return date
}

const readableDate = (date) => {
  if (!date) return ''
  const split = date.split('-')
  const newDate = split[1] + '/' + split[2] + '/' + split[0]
  return newDate
}

const monthDay = (date) => {
  if (!date) return ''
  const split = date.split('-')
  const newDate = split[1] + '/' + split[2]
  return newDate
}

export default {
  datetime,
  date,
  time,
  readableDate,
  scoreboardDate,
  monthDay
}



// WEBPACK FOOTER //
// ./src/filters/datetime.js